import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import { bindAll } from '@bibliocommons/utils-react';
import Checkbox from '@bibliocommons/deprecated-base-checkbox';
import { bibShape } from '@bibliocommons/bc-prop-types';
import BibBrief from 'app/components/shared/BibBrief';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import JacketCoverContainer from 'app/components/shared/JacketCover/JacketCoverContainer';
import ItemFormat from 'app/components/shared/ItemFormat';

import './ReturnDigitalCheckoutsModal.scss';

export default class ReturnDigitalCheckoutsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      addToShelf: false
    };
    bindAll(this);
  }

  handleClose() {
    this.props.modalActions.closeModal(this.props.modalKey);
  }

  handleAddToShelf() {
    this.setState(state => ({ addToShelf: !state.addToShelf }));
  }

  handleCheckIn(e) {
    e.preventDefault();
    const { accountId, metadataId, checkoutId, messagingId, shelfActions, bib } = this.props;
    this.props.checkIn({
      accountId,
      metadataId,
      messagingId,
      checkoutId,
      postSuccess: () => {
        if (this.state.addToShelf) {
          shelfActions.addToShelf({
            metadataId: bib.getIn(['briefInfo', 'metadataId']),
            shelfToAdd: 'completed'
          });
        }
        this.handleClose();
      }
    });
  }

  render() {
    const { modalKey, bib, isLoading } = this.props;

    return (
      <ModalContainer
        className="cp-return-checkout-item-confirmation-modal"
        modalKey={modalKey}
        handleClose={this.handleClose}
      >
        <ModalHeader title={<FormattedMessage id="return_confirmation" />} />
        <ModalContent>
          <div className="return-checkout-item-modal-content">
            <div className="return-checkout-item-info">
              <div className="return-checkout-item-item-jacket-cover">
                <JacketCoverContainer
                  src={bib.getIn(['briefInfo', 'jacket'])}
                  format={bib.getIn(['briefInfo', 'format'])}
                  alt=""
                />
              </div>
              <BibBrief
                bib={bib.getIn(['briefInfo'])}
                renderTitleAsLink={false}
                renderAuthorsAsLink={false}
                titleTag="h3"
              >
                <ItemFormat bib={bib} />
              </BibBrief>
            </div>
            <FormattedMessage id="keep_a_reference" tagName="strong" />
            <Checkbox
              id="add-overdrive-add-to-shelf"
              labelTestId="add-overdrive-to-completed"
              handleChange={this.handleAddToShelf}
              checked={this.state.addToShelf}
              label={<FormattedMessage id="add_to_my_shelf_completed" />}
            />
          </div>
        </ModalContent>
        <ModalFooter
          primaryActionButtonTag={TransactionalSolidButton}
          primaryActionButtonText={<FormattedMessage id="digital_return_now" />}
          handlePrimaryAction={this.handleCheckIn}
          isLoading={isLoading}
        />
      </ModalContainer>
    );
  }
}

ReturnDigitalCheckoutsModal.propTypes = {
  modalKey: PropTypes.string,
  modalActions: PropTypes.objectOf(PropTypes.func),
  shelfActions: PropTypes.objectOf(PropTypes.func),
  checkoutId: PropTypes.string.isRequired,
  metadataId: PropTypes.string.isRequired,
  accountId: PropTypes.number.isRequired,
  messagingId: PropTypes.string,
  isLoading: PropTypes.bool,
  bib: bibShape,
  checkIn: PropTypes.func
};
